module.exports = __webpack_public_path__ + "img/couples.93ce5d2c.jpg";